/**  
 * Allowed API status codes
*/
export enum ApiStatusCode {
    /**
     * API call was successful
     */
    Success = "success",
    /**
     * API call failed
     */
    Failure = "error",
}